import { useEffect, useRef } from "react";
import { FaWhatsapp, FaTimes } from "react-icons/fa";
import { SUPPORT_WHATSAPP_URL, SUPPORT_WHATSAPP_DISPLAY } from "../../utils/support";

const SupportModal = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      const focusable = modalRef.current.querySelector(
        'a, button, [tabindex]:not([tabindex="-1"])'
      );
      if (focusable) focusable.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[60] overflow-y-auto flex items-center justify-center p-4"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="support-modal-title"
    >
      <div
        className="relative w-full max-w-md"
        ref={modalRef}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-white rounded-xl shadow-xl border border-slate-200 animate-in fade-in slide-in-from-bottom-4 duration-300">
          {/* Header */}
          <div className="px-5 md:px-6 py-4 bg-emerald-50 border-b border-emerald-200 rounded-t-xl flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white/80 rounded-lg flex-shrink-0">
                <FaWhatsapp className="text-emerald-600 w-5 h-5" />
              </div>
              <h3
                id="support-modal-title"
                className="text-lg font-semibold text-slate-900"
              >
                Falar com o suporte
              </h3>
            </div>
            <button
              onClick={onClose}
              aria-label="Fechar"
              className="p-1 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-white/50 transition-colors duration-200"
            >
              <FaTimes className="text-sm" />
            </button>
          </div>

          {/* Body */}
          <div className="p-5 md:p-6">
            <p className="text-slate-700 leading-6 mb-3">
              Este é o nosso canal de atendimento no WhatsApp. Use-o para
              esclarecer dúvidas, informar erros ou enviar feedbacks.
            </p>
            <p className="text-sm text-slate-500 mb-6">
              Você será direcionado para uma conversa com o número{" "}
              <span className="font-medium text-slate-700">
                {SUPPORT_WHATSAPP_DISPLAY}
              </span>
              .
            </p>

            {/* Actions */}
            <div className="flex flex-col-reverse sm:flex-row gap-3">
              <button
                onClick={onClose}
                className="flex-1 bg-slate-100 text-slate-700 px-6 py-3 rounded-lg font-medium hover:bg-slate-200 focus:ring-2 focus:ring-slate-700/20 focus:outline-none transition-all duration-200"
              >
                Cancelar
              </button>
              <a
                href={SUPPORT_WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onClose}
                className="flex-1 inline-flex items-center justify-center gap-2 bg-emerald-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-emerald-700 focus:ring-2 focus:ring-emerald-600/20 focus:outline-none transition-all duration-200"
              >
                <FaWhatsapp className="w-4 h-4" />
                Abrir WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportModal;
